module.exports = __webpack_public_path__ + "img/EM_SE_Logo.cc852eb1.svg";